import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";
import Help from "../views/Help.vue";
import Contacts from "../views/Contacts.vue";
import Provinces from "../views/Provinces.vue";
import Kuchis from "../views/Kuchis.vue";
import Login from "../views/Login.vue";

import AuthGuard from "./auth-guard";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Kuchis,
      beforeEnter: AuthGuard,
      meta: { requiresAuth: true }
    },
    { path: "/help", name: "help", component: Help, beforeEnter: AuthGuard },
    { path: "/contacts", name: "contacts", component: Contacts, beforeEnter: AuthGuard },
    { path: "/provinces", name: "provinces", component: Provinces, beforeEnter: AuthGuard },
    // { path: "/kuchis", name: "kuchis", component: Kuchis, beforeEnter: AuthGuard },
    { path: "/login", name: "login", component: Login },
    {
      path: "/about",
      name: "about",
      beforeEnter: AuthGuard,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/About.vue")
    },

  ]
});
